import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class DysAPI extends BaseAPI {

  constructor() {
    const baseUrl = environment.API_URL  + 'Dys';
    super(baseUrl);
  }

  upload(formData: FormData) {
    return this.axiosInstance.post('upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response: any) => response.data);
  }

  obBasvuruTanimBelgeList(request: ObBasvuruTanimBelgeListRequest) {
    return this.post('obBasvuruTanimBelgeList',request);
  }
}

export default new DysAPI();

class UploadRequest {    
  files?: File[];
  basvuruTuru?: number;
  basvuruId?: string;
  folderName?: string;
  kurumId?: number;
  versionable?: number;    
  rfObBasvuruTanimBelge?: number; 

  constructor(init?: Partial<UploadRequest>) {
    Object.assign(this, init);
  }
}
export { UploadRequest };

class ObBasvuruTanimBelgeListRequest {
    rfObBasvuruTanim?: number;
    zorunluEh?: string;

    constructor(
        rfObBasvuruTanim?: number,
        zorunluEh?: string,
    ) {
        this.rfObBasvuruTanim = rfObBasvuruTanim;
        this.zorunluEh = zorunluEh;
    }
}
export { ObBasvuruTanimBelgeListRequest };
